/* jQuery fixed_float */
/**
 *
 * Version: 1.0 (11/03/2015)
 * Requires: jQuery v1.8+
 *
 * Copyright (c) 2012 Anthony Terrien
 * Under MIT and GPL licenses:
 *  http://www.opensource.org/licenses/mit-license.php
 *  http://www.gnu.org/licenses/gpl.html
 *
 * Специально для topvisor.ru
 */

// Пример: <div class="fixed_float" data-fixed_float-direction="v">Плавающий блок</div>

$(function(){
	$('.fixed_float').fixed_float();
});

(function($) {
	$.fn.fixed_float = function(options){
		$.map(this, function(el){
			var $this = $(el);

			if($this.data('fixed_float')) return; // already

			var direction = $this.data('fixed_float-direction');

			var $plugin = $this;
			$plugin.options = $.extend({
				$wrapper:false,
				top:0,
				left:0,
				direction:direction||'v' // h/v/hv
			}, options);

			// функции инициализациии плагина
			$plugin.init = function(){
				$plugin.data('fixed_float', $plugin);

				$plugin.wrap('<div>');
				$plugin.options.$wrapper = $plugin.parent();
				var h = $plugin.outerHeight()+$plugin.css('border-top-width').replace('px', '')*1+$plugin.css('border-bottom-width').replace('px', '')*1;
				$plugin.options.$wrapper.css('height', h).addClass('fixed_float_wrapper');
				$plugin.options.top = $plugin.options.$wrapper.offset().top;
				$plugin.options.left = $plugin.options.$wrapper.offset().left;

				$(window).scroll($plugin.onScroll);
			}

			$plugin.onScroll = function(event){
				// fix reposition block
				$plugin.options.top = $plugin.options.$wrapper.offset().top;
				$plugin.options.left = $plugin.options.$wrapper.offset().left;

				var top = $plugin.options.top;
				var left = $plugin.options.left;
				var scrollTop = $(window).scrollTop();
				var scrollLeft = $(window).scrollLeft();

				$plugin.removeClass('fixed_float_active');
				$plugin.css({top:'auto', left:'auto'});

				switch($plugin.options.direction){
					case 'h':
						if(scrollLeft > left){
							$plugin.addClass('fixed_float_active');
							$plugin.css({top:top-scrollTop, left:0});
						}
					break;
					case 'v':
						if(scrollTop > top){
							$plugin.addClass('fixed_float_active');
							$plugin.css({top:0, left:left-scrollLeft});
						}
					break;
					case 'hv':
						if(scrollTop > top || scrollLeft > left){
							var new_top = top-scrollTop;
							var new_left = left-scrollLeft;
							if(new_top < 0) new_top = 0;
							if(new_left < 0) new_left = 0;

							$plugin.addClass('fixed_float_active');
							$plugin.css({top:new_top, left:new_left});
						}
					break;
				}
			}

			$(window).resize($plugin.onScroll);

			$plugin.init();
		});

		return this;
	};
})(jQuery);